// extracted by mini-css-extract-plugin
export default {"tab":"tab_tab__gX7fy","selected":"tab_selected__tRIlR"};